export default "__VITE_ASSET__Dkuke_It__"